import { render, staticRenderFns } from "./tableOfContents.vue?vue&type=template&id=629541c2&scoped=true"
import script from "./tableOfContents.vue?vue&type=script&lang=js"
export * from "./tableOfContents.vue?vue&type=script&lang=js"
import style0 from "./tableOfContents.vue?vue&type=style&index=0&id=629541c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629541c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629541c2')) {
      api.createRecord('629541c2', component.options)
    } else {
      api.reload('629541c2', component.options)
    }
    module.hot.accept("./tableOfContents.vue?vue&type=template&id=629541c2&scoped=true", function () {
      api.rerender('629541c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableOfContents.vue"
export default component.exports